export const general = {
  settings : 'settings',
  organisation : 'organisation',
  network : 'network',
  client: 'client',
  commercial: 'commercial',
  domain: 'secteur',
  functionality: 'functionality',
  module: 'module',
  typePack: 'typePack',
  pack: 'pack',
  profile: 'profile',
  list: 'list',
  add: 'add',
  update: 'update',
  detail: 'detail',
  support : 'support',
  dashboard : 'dashboard',
  payement : 'payment',
  logs : 'logs'
};
export const path = {
  settings : general.settings,
  network :  general.network,
  organisation :  general.organisation,
  support : general.support,
  dashboard : general.dashboard,
  profile : general.profile,
  domainList: general.domain+'/'+general.list,
  moduleList: general.module+'/'+general.list,
  typePackList: general.typePack+'/'+general.list,
  functionalityList: general.functionality+'/'+general.list,
  packList: general.pack+'/'+general.list,
  clientList: general.client+'/'+general.list,
  commercialList: general.commercial+'/'+general.list,
  organisationList: general.organisation+'/'+general.list,
  organisationPayment: general.organisation+'/'+general.payement,

  domainAdd: general.domain+'/'+general.add,
  moduleAdd: general.module+'/'+general.add,
  typePackAdd: general.typePack+'/'+general.add,
  functionalityAdd: general.functionality+'/'+general.add,
  clientAdd: general.client+'/'+general.add,
  commercialAdd: general.commercial+'/'+general.add,
  organisationAdd: general.organisation+'/'+general.add,

  domainUpdate: general.domain+'/'+general.update,
  moduleUpdate: general.module+'/'+general.update,
  typePackUpdate: general.typePack+'/'+general.update,
  functionalityUpdate: general.functionality+'/'+general.update,
  packUpdate: general.pack+'/'+general.detail,
  clientUpdate: general.client+'/'+general.update,
  commercialUpdate: general.commercial+'/'+general.update,
  organisationUpdate: general.organisation+'/'+general.update,
  logs: general.logs
};
export const name = {
    settings : general.settings,
    network :  general.network,
    organisation :  general.organisation,
    support : general.support,
    dashboard : general.dashboard,
    profile : general.profile,
    domainList : general.settings,
    clientList: general.network,
    organisationList: general.organisation,
    moduleList: 'listModule',
    typePackList: 'listTypePack',
    functionalityList: 'listFunctionality',
    packList: 'listPack',
    commercialList: 'listCommercial',
    domainUpdate : 'UpdateSecteur',
    moduleUpdate : 'UpdateModule',
    typePackUpdate : 'UpdateTypePack',
    functionalityUpdate : 'UpdateFunctionality',
    packUpdate : 'detailPack',
    clientUpdate : 'UpdateClient',
    commercialUpdate : 'UpdateCommercial',
    organisationUpdate : 'UpdateOrganisation',
    domainAdd : 'addSecteur',
    moduleAdd : 'addModule',
    typePackAdd : 'addTypePack',
    clientAdd : 'addClient',
    commercialAdd : 'addCommercial',
    organisationAdd : 'addOrganisation',
    functionalityAdd : 'addFunctionality',
    payment: 'payment',
    paymentStep: 'paymentStep',
    logs: general.logs
};


